export class Tag {
  id     = -1;
  type   = '';
  label  = '';
  value  = '';
  data   = {};
  origin = '';
}
